/**
 * @name validateErrors
 * @public
 * @description Checks if the provided GraphQL errors contain any unauthorized status codes.
 * Specifically looks for 401 and 403 HTTP status codes in the error extensions.
 * @param {Array<Object>} errors - Array of GraphQL error objects with extensions
 * @param {Object} [errors[].extensions]
 *  Error extension object potentially containing response data
 * @param {Object} [errors[].extensions.response] - Response object with status code
 * @returns {boolean} Returns true if no unauthorized errors found, false otherwise
 */
export default function validateErrors(errors) {
  const unauthorizedStatuses = [401, 403];

  const findErrorStatusFromList = ({ extensions }, list) => (
    list.includes(extensions?.response?.status)
  );

  if (!errors?.find((err) => findErrorStatusFromList(err, unauthorizedStatuses))) {
    return true;
  }

  return false;
}
